export const JIBBLE_INTEGRATION_STATUS_QUERY = 'jibbleActivationStatus';
export const JIBBLE_GET_ATTENDANCE_SETTINGS = 'jibbleAttendanceSettings';
export const JIBBLE_INITIAL_EMPLOYEES_SYNC = 'jibbleInitialEmployeesSync';
export const JIBBLE_GET_EMPLOYEE_DATA = 'jibbleEmployeeData';
export const JIBBLE_GET_SYNCED_ATTENDANCE_REPORT = 'jibbleGetSyncedAttendanceReport';
export const JIBBLE_GET_LOP_ADDITION_STATUS = 'jibbleLopAdditionStatus';